import { INVENTORY_QUERY_FRAGMENT } from '../../../../common/inventory/services/InventoryService';
import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { DateUtils } from '../../../../common/utils/DateUtils';
import { OrganizationExportOptions } from '../../../options/OrganizationExportOptions';
import { OrganizationPrintMapper } from '../mappers/OrganizationPrintMapper';
import { OrganizationPrintData } from '../models/OrganizationPrintData';

export const GET_TRENDS_ORGANIZATION_PRINT_QUERY = `
query ($tags: [String!], $projectIds: [String!], $profileIds: [String!], $includeExceptions: Boolean!, $overviewTypes: [OverviewType!], $fromDate: DateTime!, $toDate: DateTime!) {
  viewer {
    organization {
      name
      inventory(tags: $tags, projectIds: $projectIds, profileIds: $profileIds, overviewTypes: $overviewTypes, from: $fromDate, to: $toDate) {
        ${INVENTORY_QUERY_FRAGMENT}
      }
      vulnerabilities(tags: $tags, projectIds: $projectIds, profileIds: $profileIds, overviewTypes: $overviewTypes, withExceptions: $includeExceptions, from: $fromDate, to: $toDate) {
        edges {
          node {
            number
            title
            shortExplanation
            severity
            numberOfSlots
          }
        }
      }
    }
  }
}
`;

export class OrganizationPrintRepository extends BaseGQLService {
  private readonly mapper = new OrganizationPrintMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getTrendsOrganization(options: OrganizationExportOptions): Promise<OrganizationPrintData> {
    const { tags = [], projects = [], profiles = [], overviews = [], withExceptions, dateRange } = options;

    const [from, to] = dateRange;

    return this.query(
      GET_TRENDS_ORGANIZATION_PRINT_QUERY,
      {
        tags,
        profileIds: profiles.map((p) => p.getId()),
        projectIds: projects.map((p) => p.getId()),
        includeExceptions: withExceptions,
        overviewTypes: overviews,
        fromDate: from !== null ? DateUtils.toISOString(from) : null,
        toDate: to !== null ? DateUtils.toISOString(to) : null,
      },
      (data) => this.mapper.mapGQLModel(data.viewer.organization, tags, projects, profiles)
    );
  }
}
